import { ChangeDetectionStrategy, Component, ElementRef, inject, output } from '@angular/core';
import { ActivitySectionDirective, SpecialsService, UserActivityClickTrackingDirective } from '@core';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';
import { SwiperContainerComponent } from '@core/lib/components/swiper/swiper-container.component';
import { SwiperSlideComponent } from '@core/lib/components/swiper/swiper-slide.component';
import { LoadingComponent } from '@app/components/loading/loading.component';
import { map } from 'rxjs/operators';
import { toSignal } from '@angular/core/rxjs-interop';
import { SwiperVideoControlDirective } from '@core/lib/components/swiper/swiper-video-control.directive';

@Component({
  selector: 'app-more-events',
  templateUrl: './events.component.html',
  styleUrl: './events.component.scss',
  imports: [
    ActivitySectionDirective,
    PageHeaderComponent,
    UserActivityClickTrackingDirective,
    SwiperContainerComponent,
    SwiperSlideComponent,
    LoadingComponent,
    SwiperVideoControlDirective,
  ],
  host: {
    class: 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EventsComponent {

  private readonly specialsService = inject(SpecialsService);
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    element: this.elementRef.nativeElement,
  };

  private readonly events$ = this.specialsService.specials$.pipe(
    map((specials) => {
      return specials?.filter(special => special.name.startsWith('[event]'));
    }),
  );

  public readonly events = toSignal(this.events$);

  public readonly loading = toSignal(this.specialsService.loading$, {
    initialValue: true,
  });

  public readonly back = output();

}
